import type { HTMLAttributes, ReactNode } from 'react'
import { IconArrowLeft } from '@/components/Icons'

export function Page({ children, className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`ui-page ${className}`.trim()} {...props}>
      {children}
    </div>
  )
}


export interface PageHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  subtitle?: ReactNode
  action?: ReactNode
  onBack?: () => void
  children?: ReactNode
}

export function PageHeader({ title, subtitle, action, onBack, children, className = '', ...props }: PageHeaderProps) {
  return (
    <div className={`ui-header ui-header--between ${className}`.trim()} {...props}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
        {onBack && (
          <button className="ui-back-btn" onClick={onBack}>
            <IconArrowLeft /> Voltar
          </button>
        )}
        <div>
          <h1 className="ui-title">{title}</h1>
          {subtitle && <p className="ui-subtitle">{subtitle}</p>}
        </div>
      </div>
      {(children || action) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {children}
          {action && <div>{action}</div>}
        </div>
      )}
    </div>
  )
}

Page.Header = PageHeader

export function PageContent({ children, className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`ui-page-content ${className}`.trim()} {...props}>
      {children}
    </div>
  )
}

Page.Content = PageContent
